export default {
    props: {
        modelValue: {
            type: String,
        },
        type: {
            type: String,
            required: true,
        },
        title: {
            type: String,
            required: true,
        },
    },
    data() {
      return {
        value: "+",
      }
    },
    methods: {
        onChangeHandler() {
            this.$emit('update:value', this.modelValue)
        }
    },
    template: `
    <label class="search-field "> 
        <span class="search-field__label">{{ title }}:</span>
        <input
            :value="modelValue"
            class="search-field__input"
            :type="type"
            @input="$emit('update:modelValue', $event.target.value)"
            @change="onChangeHandler"
        >
    </label>
    `
}
